import React from "react";
import "./Nav.css";

const Nav = () => {
  return (
    <nav className="navbar">
      <div className="circle"></div>
      <ul className="nav-links">
        <li>
          <a href="#about">about</a>
        </li>
        <li>
          <a href="#projects">projects</a>
        </li>
        
      </ul>
    </nav>
  );
};

export default Nav;
